export const TherapyStatusEnum = {
  IN_PROGRESS: "IN_PROGRESS",
  IN_QUEUE: "IN_QUEUE",
  IN_QUEUE_WITH_ERROR: "IN_QUEUE_WITH_ERROR",
  SYNCED: "SYNCED",
  NOT_SYNCED: "NOT_SYNCED",
};
